import PropTypes from 'prop-types';
import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { sendComment } from '~/actions/article'

class NewComment extends React.Component {
    static propTypes = {
		articleID: PropTypes.number,
	};

    state = {
        comment: ''
    };

    updateComment = (e) => {
		this.setState({
			comment: e.target.value
		})
	};

    submitComment = () => {
		this.props.sendComment( this.props.articleID, this.state.comment )
		this.setState({
			comment: ''
		})
	};

    render() {

		return (
			<div className="new-comment bg-white border-light-gray p10 mbot20 text-right">
				<div className="row">
					<div className="col-sm-2 hidden-xs">
						<div className="profile-image" style={{backgroundImage: 'url(' + this.props.user.profile_picture + ')'}} />
					</div>
					<div className="col-sm-10">
			    		<textarea 	className="form-control border-off-white mbot10" 
			    					onChange={this.updateComment}
			    					rows="4"
	    							value={this.state.comment} />
		    		</div>
				</div>
	    		<button onClick={this.submitComment} className="btn btn-primary" disabled={!this.state.comment}>Post</button>
    		</div>
		)

	}
}

const mapStateToProps = state => ({
    user: state.session.user,
});

const mapDispatchToProps = dispatch => bindActionCreators({ sendComment }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewComment);



// WEBPACK FOOTER //
// ./src/js/views/Article/components/Comments/components/NewComment.js